import React from "react";
import { FlutterSec } from "./flutter";

export const Flutter = () => {
  return (
    <React.Fragment>
      <div className="flutter-main">
        <FlutterSec />
      </div>
    </React.Fragment>
  );
};
